'use client';

import { useSearchParams } from 'next/navigation';

export const useWebView = () => {
    const searchParams = useSearchParams();

    const webViewQueryParamValue = searchParams?.get('iswebview');

    return webViewQueryParamValue === 'true';
};
